import { Modal } from '@vzmi/shp_shared_compo'

const SortConfirmModal = props => {
  const {
    visible,
    onOk,
    onCancel,
    ...restProps
  } = props
  return (
    <Modal
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      okText='更換排序'
      className='sort-confirm-modal'
      {...restProps}
    >
      <br />
      更換排序後，賣場第一張商品圖將被替換，
      <br />
      你確定要更換商品排序？
    </Modal>
  )
}

export default SortConfirmModal
